import script from "./ResetPasswordView1.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResetPasswordView1.vue?vue&type=script&lang=ts&setup=true"

import "./ResetPasswordView1.vue?vue&type=style&index=0&id=4cb30685&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb30685"]])

export default __exports__